import React, { Fragment, useEffect, useState, FC, ReactElement } from 'react';
import { Row, Col, Card, Button, Form, Collapse } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faFilter, faPlus, faMinus, faRedo } from '@fortawesome/free-solid-svg-icons';
import { useForm, Controller } from "react-hook-form";
import DropdownCheckboxes from "../../DropdownCheckboxes";
import { InputDate, ErrorMessage, Dropdown } from "../../../../lib/ui";
import { CarteFilterForm } from "../../../../types/forms/carteForms";
import { CarteFilterProps } from "../../../../types/components/carteComponent";
import { CommunicationStatus } from "../../../../types/entities/communicationEntities";
import { useComService } from "../../../../service/communication/comService";
import { useCarteService } from "../../../../service/communication/carteService";
import { yupResolver } from '@hookform/resolvers/yup';
import { validationGetParamSchema } from '../validators/getValidator';
import GenericDate from 'components/common/generic/GenericDate';
import moment from 'moment';

export const CarteFilter: FC<CarteFilterProps> = (): ReactElement => {
    const [collapse, setCollapse] = useState<boolean>(false);
    const [statusList, setStatusList] = useState<Array<CommunicationStatus>>([]);

    const service = useComService();
    const carteService = useCarteService();

    const { handleSubmit, watch, control, setValue, errors, reset, setError, getValues } = useForm<CarteFilterForm>({
        defaultValues: carteService.Filter.defaultValues,
        reValidateMode: 'onChange',
        resolver: yupResolver(validationGetParamSchema),
        mode: "onChange",
    });
    const values = watch();

    useEffect(()=> {
        if(values.dateDebut && values.dateFin) {
            if (moment(values.dateDebut).isBefore(values.dateFin)) {
                setError('dateDebut', { message: '' });
            }

            if (moment(values.dateFin).isAfter(values.dateDebut)) {
                setError('dateFin', { message: '' });
            }
        }
    }, [values.dateDebut, values.dateFin])


    const fetchData = (reset = false): void => {
        carteService.request.GetAll.process(carteService.mapToParam(reset? carteService.Filter.defaultValues : getValues(), reset? service.getOptionsStatus() : statusList));
    }

    useEffect(() => {
        service.request.StatusGet.actions.process({ communicationType: 3 })
    }, []);

    useEffect(() => {
        if(service.request.getStatus.isSuccess) {
            setStatusList(service.getOptionsStatus())
            fetchData(true);
        }
    }, [service.request.getStatus.isSuccess]);

    const COLLECTIONS_OPTIONS = [
        { label: "Date de création", value: "2" },
        { label: "Date de début", value: "0" },
        { label: "Date de fin", value: "1" },
    ];

    return (
        <Fragment>
            <div className='config-mt-15'>

                <Card className='card-alert-border'>
                    <Card.Header onClick={() => { setCollapse(!collapse); }}>
                        <span className='header-filter-config'>
                            <FontAwesomeIcon icon={faFilter} /> Filtres
                        </span>

                        <Button onClick={(ev) => {
                            ev.stopPropagation()
                              reset(carteService.Filter.defaultValues);
                              carteService.cleanCache();
                              setStatusList(service.getOptionsStatus());

                              fetchData(true);
                            }} className="ml-4">
                            <FontAwesomeIcon icon={faRedo} /> Réinitialiser
                        </Button>

                        <Button variant="light" className='btn-filter-collapse' onClick={() => { setCollapse(!collapse); }}>
                            <FontAwesomeIcon icon={!collapse ? faPlus : faMinus} />
                        </Button>
                    </Card.Header>
                    <Collapse in={collapse}>
                        <Card.Body className='card-alert-body'>
                            <Form 
                                onSubmit={handleSubmit(() => {
                                    carteService.cleanCache();
                                    fetchData();
                                })}
                            >
                                <Row className='config-mt-10 form-row-alert'>

                                    <Col xl={5} lg={10} md={11} className={`p-0 ml-xl-3 ml-lg-4 ml-md-3 mt-lg-0  mt-md-4`}>
                                        <Controller
                                            control={control}
                                            name="filterByDateType"
                                            render={({ onChange, value }, { invalid }) => {
                                                return (
                                                    <Dropdown
                                                        mode="select"
                                                        label={"Filtrer par"}
                                                        options={COLLECTIONS_OPTIONS}
                                                        onChange={onChange}
                                                        selectedValue={value}   
                                                        defaultValue={carteService.Filter.defaultValues.filterByDateType}
                                                    />
                                                );
                                            }}
                                        />
                                    </Col>

                                    <Col xl={3} lg={5} md={11} className={`p-0 ml-xl-3 ml-lg-4 ml-md-3 mt-lg-0  mt-md-4`}>
                                        <Controller
                                            control={control}
                                            name="dateDebut"
                                            value={values.dateDebut}
                                            render={({ onChange, value }, { invalid }) => {
                                                return (
                                                    <GenericDate
                                                        label="Du"
                                                        date={value}
                                                        onDateChange={onChange}
                                                        width={'80'}
                                                        cssClass='alert-input-date'
                                                        isRequired
                                                        //format={carteService.Constantes.DISPLAY_DATE_FORMAT}
                                                        //title="date de debut"
                                                    />
                                                );
                                            }}
                                        />
                                        {errors.dateDebut && <ErrorMessage>{errors.dateDebut.message}</ErrorMessage>}
                                    </Col>

                                    <Col xl={3} lg={5} md={11} className={`p-0 ml-xl-3 ml-lg-4 ml-md-3 mt-lg-0  mt-md-4`}>
                                        <Controller
                                            control={control}
                                            name="dateFin"
                                            value={values.dateFin}
                                            render={({ onChange, value }, { invalid }) => {
                                                return (
                                                    <GenericDate
                                                        label="Au"
                                                        date={value}
                                                        onDateChange={onChange}
                                                        width={'80'}
                                                        cssClass='alert-input-date'
                                                        isRequired
                                                        //format={carteService.Constantes.DISPLAY_DATE_FORMAT}
                                                        //title="date de fin"
                                                    />
                                                );
                                            }}
                                        />
                                        {errors.dateFin && <ErrorMessage>{errors.dateFin.message}</ErrorMessage>}
                                    </Col>
                                </Row>

                                <Row className='config-mt-10 form-row-alert'>
                                    <Col xl={12} md={12} className={`p-0 pt-1 mt-xl-0 mt-lg-4 ml-xl-3 ml-lg-3 ml-md-3  pr-0 mr-0 mt-md-4`}>
                                        <div className={`mr-xl-0 mr-lg-0 mr-md-0 card-display-inline`}>
                                        <DropdownCheckboxes
                                            valueList={statusList}
                                                onChange={(value, evt) => {
                                                    service.handleDropdownFilterChange(value, evt, setStatusList, service.getOptionsStatus());
                                            }}
                                            cssContainerClass={'com-dropdown-checkbox-container'}
                                            cssClass={'com-dropdown-checkbox'}
                                            hideSearch={true}
                                            defaultLabel={'Tous les statuts'}
                                            label={'Statut'}
                                            labelButton={"choisis"}
                                            optionData={service.getOptionsStatus()}
                                            labelNone={''}
                                            numberOptions={
                                                service.request.StatusGet.result.data && service.request.StatusGet.result.data.length >= 1
                                                    ? service.getOptionsStatus().length - 1
                                                    : null
                                            }
                                            getOptionValue={(option) => option.value}
                                        />
                                        </div>
                                        <div className='ml-xl-3 ml-lg-3 ml-md-3 mr-xl-3 mr-lg-3 mr-md-3 card-display-inline'>
                                            <Button type="submit">
                                                <FontAwesomeIcon icon={faSearch} /> Rechercher
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Collapse>
                </Card>
            </div>
        </Fragment>
    );
}

export default CarteFilter;
